import React from "react";
import { connect } from "react-redux";
import appConfig from "../../config/appConfig";
import { verifyPermission } from "../../helpers/permission";
import { ERROR_401 } from "../../config/errorPage";
import ImportFileForm from "../components/ImportFileForm";
import { useTranslation } from "react-i18next";

const UnfoundedReasonImportPage = (props) => {
  const { t, ready } = useTranslation();
  
  if (!verifyPermission(props.userPermissions, "store-unfounded-reasons"))
    window.location.href = ERROR_401;

  return ready ? (
    <ImportFileForm
      submitEndpoint={`${appConfig.apiDomaine}/import-unfounded-reasons`}
      pageTitleLink="/settings/unfounded-reasons/add"
      pageTitle={t("Motifs de non-fondé")}
      panelTitle={t("Importation des motifs de déclassement non fondé au format Excel")}
    />
  ) : null;
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
});

export default connect(mapStateToProps)(UnfoundedReasonImportPage);